import React, { Fragment, useEffect, useRef, useState, useMemo } from "react";
import { connect } from "react-redux";
import swal from "sweetalert";
import { Link } from "react-router-dom";
import ProductItem from "./ProductItem";
import selectCpaps from "../../../selectors/cpaps";
import DetailModal from "./DetailModal";
import { db } from "../../../firebase";
import {
  doc,
  onSnapshot,
  getDocs,
  getDoc,
  orderBy,
  limit,
  where,
  query,
  collection,
  and,
  or,
} from "firebase/firestore";
import {
  startSetCpaps,
  startEditCpap,
  startRemoveCpap,
} from "../../../actions/cpaps";
import { Dropdown, Button, Col, Table, Card, Row } from "react-bootstrap";
import { useAuth } from "../../../context/AuthContext";
import PageTitle from "../../layouts/PageTitle";
// import orderFormFields from "./orderFormFields";
import formFields from "./formFields";
import orderFormFields from "./orderFormFields";
import { usePagination } from "../../../hook/usePagination";

const ProductList = (props) => {
  const { currentUser } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [edit, setEdit] = useState({});
  const [searchItem, setSearchItem] = useState("");
  const [showReservationBreakdown, setShowReservationBreakdown] =
    useState(false);
  const [salesFilter, setSalesFilter] = useState("ทั้งหมด");
  const [salesSelect, setSalesSelect] = useState(["ทั้งหมด"]);
  const [statusFilter, setStatusFilter] = useState("ทั้งหมด");
  const searchRef = useRef(null);

  const statusSelect = [
    "ทั้งหมด",
    "ว่าง",
    "จอง",
    "ขาย",
    "ยกเลิก",
    "เครื่องตัวอย่าง",
  ];

  const itemPerPage = 50;

  let QueryFilterConstraint = [];
  let queryRef = query(
    collection(db, "products"),
    orderBy("status", "desc"),
    orderBy("createdAt", "desc")
  );

  if (searchItem !== "") {
    QueryFilterConstraint.push(
      where("serialNumber", ">=", searchItem),
      where("serialNumber", "<=", searchItem + "\uf8ff")
    );
  }

  if (salesFilter !== "ทั้งหมด") {
    QueryFilterConstraint.push(where("sales", "==", salesFilter));
  }

  if (statusFilter !== "ทั้งหมด") {
    QueryFilterConstraint.push(where("status", "==", statusFilter));
  }

  if (QueryFilterConstraint.length > 0) {
    queryRef = query(
      collection(db, "products"),
      and(...QueryFilterConstraint),
      orderBy("status", "desc"),
      orderBy("createdAt", "desc")
    );
  }

  const {
    items: productList,
    isLoading,
    isStart,
    isEnd,
    getPrev,
    getNext,
    totalItems,
    totalPages,
    currentPage,
    goToPage,
  } = usePagination(queryRef, { limit: itemPerPage });

  // console.log(productList);

  // Calculate statistics for all CPAPs from Redux store
  const cpapStats = useMemo(() => {
    const stats = {
      total: props.cpaps.length,
      available: 0,
      reserved: 0,
      sold: 0,
      cancelled: 0,
      demo: 0,
      byModel: {},
      availableByModel: {},
      reservedByModel: {},
      soldByModel: {},
      reservedBySalesRep: {},
    };

    props.cpaps.forEach((cpap) => {
      const status = cpap.status;
      const model = cpap.model || "Other";

      // Count by status
      if (status === "ว่าง") {
        stats.available++;
        stats.availableByModel[model] =
          (stats.availableByModel[model] || 0) + 1;
      } else if (status === "จอง") {
        stats.reserved++;
        stats.reservedByModel[model] = (stats.reservedByModel[model] || 0) + 1;

        // Track reservations by sales rep and model
        const salesRep = cpap.sales || "Unassigned";
        if (!stats.reservedBySalesRep[salesRep]) {
          stats.reservedBySalesRep[salesRep] = {};
        }
        stats.reservedBySalesRep[salesRep][model] =
          (stats.reservedBySalesRep[salesRep][model] || 0) + 1;
      } else if (status === "ขาย") {
        stats.sold++;
        stats.soldByModel[model] = (stats.soldByModel[model] || 0) + 1;
      } else if (status === "ยกเลิก") {
        stats.cancelled++;
      } else if (status === "เครื่องตัวอย่าง") {
        stats.demo++;
      }

      // Count all by model
      stats.byModel[model] = (stats.byModel[model] || 0) + 1;
    });

    return stats;
  }, [props.cpaps]);

  const handleOnEdit = (id) => {
    const data = productList.find((c) => c.id === id);

    const ref = collection(db, `products/${data.id}/cpapfile`);
    let queryHandler = query(ref, where("title", "==", "CPAP Image"));

    console.log("edit cpap data", data);

    setEdit(data);
    setShowModal(true);
  };

  const handleOnHide = (sn) => {
    setShowModal(false);
  };

  const handleOnDelete = (id) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        props.startRemoveCpap({ id });
        swal(`Poof! Your file has been deleted!`, {
          icon: "success",
        });
      } else {
        swal("Canceled");
      }
    });
  };

  const onSearchChange = () => {
    setSearchItem(searchRef.current.value);
  };

  const onSalesChange = (option) => {
    setSalesFilter(option);
  };

  const onStatusChange = (option) => {
    setStatusFilter(option);
  };

  const getAvailableCPAP = (cpaps, isReserve, model, sale) => {
    const cpapAvailableList = cpaps.filter((cpap) => {
      let isAvailable;
      if (isReserve == true) {
        isAvailable = cpap.status === "จอง";
      } else {
        isAvailable = cpap.status === "ว่าง";
      }

      // If brand is provided, add it as a condition
      if (model) {
        isAvailable =
          isAvailable &&
          cpap.model.trim().toLowerCase() === model.trim().toLowerCase();
      }

      // If sale is provided, add it as a condition
      if (sale) {
        isAvailable = isAvailable && cpap.sales === sale;
      }
      return isAvailable;
    });
    return cpapAvailableList;
  };

  useEffect(() => {
    props.startSetCpaps();
    // setStateprops.cpaps

    // Fetch sales rep list
    const fetchSalesReps = async () => {
      try {
        const salesQuery = query(
          collection(db, "sales"),
          where("status", "==", "Available")
        );
        const salesSnapshot = await getDocs(salesQuery);
        const salesList = salesSnapshot.docs.map((doc) => doc.data().name);
        setSalesSelect(["ทั้งหมด", ...salesList]);
      } catch (error) {
        console.error("Error loading sales representatives:", error);
      }
    };

    fetchSalesReps();
  }, []);
  // console.log("Reserv: ",getAvailableCPAP(props.cpaps, true, "XT-Auto", null))
  return (
    <Fragment>
      <PageTitle activeMenu="Product List" motherMenu="Sales" />
      <DetailModal
        show={showModal}
        hide={handleOnHide}
        cpap={edit}
        onEditSubmit={(id, updates, files) =>
          props.startEditCpap(id, updates, files)
        }
      />
      {/* CPAP Summary Dashboard */}
      <div className="col-xl-12 col-xxl-12 mb-4">
        <div className="row">
          <div className="col-xl-3 col-lg-6 col-sm-6">
            <div className="widget-stat card bg-primary pt-4 pb-4">
              <div className="card-body text-white text-center">
                <h3 className="text-white">{cpapStats.total}</h3>
                <p className="mb-0">Total CPAPs</p>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-6 col-sm-6">
            <div className="widget-stat card bg-success pt-4 pb-4">
              <div className="card-body text-white text-center">
                <h3 className="text-white">{cpapStats.available}</h3>
                <p className="mb-0">Available</p>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-6 col-sm-6">
            <div className="widget-stat card bg-warning pt-4 pb-4">
              <div className="card-body text-white text-center">
                <h3 className="text-white">{cpapStats.reserved}</h3>
                <p className="mb-0">Reserved</p>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-6 col-sm-6">
            <div className="widget-stat card bg-danger pt-4 pb-4">
              <div className="card-body text-white text-center">
                <h3 className="text-white">{cpapStats.sold}</h3>
                <p className="mb-0">Sold</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Reserved Products Breakdown by Sales Rep */}
      {cpapStats.reserved > 0 && (
        <div className="col-xl-12 col-xxl-12 mb-4">
          <Card>
            <Card.Header
              className="d-flex justify-content-between align-items-center cursor-pointer py-2"
              onClick={() =>
                setShowReservationBreakdown(!showReservationBreakdown)
              }
              style={{ cursor: "pointer" }}
            >
              <h6 className="mb-0 font-weight-bold">Reserved Detail</h6>
              <i
                className={`fa fa-chevron-${
                  showReservationBreakdown ? "up" : "down"
                } ml-2`}
                style={{ fontSize: "12px" }}
              ></i>
            </Card.Header>
            {showReservationBreakdown && (
              <Card.Body>
                <Row>
                  {Object.entries(cpapStats.reservedBySalesRep).map(
                    ([salesRep, models]) => {
                      const totalCount = Object.values(models).reduce(
                        (sum, count) => sum + count,
                        0
                      );
                      return (
                        <Col
                          xl={6}
                          lg={6}
                          md={12}
                          key={salesRep}
                          className="mb-3"
                        >
                          <div className="border-left border-primary pl-3">
                            <h6 className="text-primary mb-2">
                              {salesRep}{" "}
                              <span className="badge badge-primary badge-pill">
                                {totalCount} {totalCount > 1 ? "units" : "unit"}
                              </span>
                            </h6>
                            <ul className="list-unstyled ml-3">
                              {Object.entries(models).map(([model, count]) => (
                                <li key={model} className="mb-1">
                                  <i className="fa fa-angle-right text-primary mr-2"></i>
                                  {model}: <strong>{count}</strong>{" "}
                                  {count > 1 ? "units" : "unit"}
                                </li>
                              ))}
                            </ul>
                          </div>
                        </Col>
                      );
                    }
                  )}
                </Row>
              </Card.Body>
            )}
          </Card>
        </div>
      )}

      <div className="form-head d-flex mb-3 mb-lg-5 align-items-start">
        <Link
          to="/product-register"
          className="btn btn-danger"
          data-toggle="tooltip"
          data-placement="top"
          title="Product Registration"
        >
          + New Product
        </Link>
        <div className="input-group search-area ml-auto d-inline-flex">
          <input
            type="text"
            className="form-control"
            placeholder="Search serial number here"
            ref={searchRef}
            onChange={onSearchChange}
          />
          <div className="input-group-append">
            <span className="input-group-text c-pointer">
              <i className="flaticon-381-search-2"></i>
            </span>
          </div>
        </div>
        <Dropdown className="ml-2" onSelect={onSalesChange}>
          <Dropdown.Toggle variant="outline-primary" id="dropdown-sales">
            <i className="flaticon-381-controls-3"></i> Sales {salesFilter}
          </Dropdown.Toggle>
          <Dropdown.Menu className="dropdown-menu-right">
            {salesSelect.map((element, index) => (
              <Dropdown.Item href="#" eventKey={element} key={index}>
                {element}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
        <Dropdown className="ml-2" onSelect={onStatusChange}>
          <Dropdown.Toggle variant="outline-primary" id="dropdown-status">
            <i className="flaticon-381-controls-3"></i> Status {statusFilter}
          </Dropdown.Toggle>
          <Dropdown.Menu className="dropdown-menu-right">
            {statusSelect.map((element, index) => (
              <Dropdown.Item href="#" eventKey={element} key={index}>
                {element}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
      {cpapStats.available > 0 && (
        <div
          className="alert alert-success py-2 px-3 mb-3 d-flex flex-wrap align-items-center"
          style={{ fontSize: "12px", lineHeight: "1.4" }}
        >
          <span className="font-weight-bold mr-2">Available by model:</span>
          {Object.entries(cpapStats.availableByModel)
            .sort(([, countA], [, countB]) => countB - countA)
            .map(([model, count]) => (
              <span key={model} className="mr-3 my-1 text-nowrap">
                {model}
                <span
                  className="badge badge-success ml-1 px-2"
                  style={{
                    fontSize: "13px",
                    fontWeight: 700,
                    lineHeight: "1.2",
                    minWidth: "24px",
                  }}
                >
                  {count}
                </span>
              </span>
            ))}
        </div>
      )}
      {!isLoading && (
        <ProductItem
          cpaps={productList}
          onEdit={handleOnEdit}
          onDelete={handleOnDelete}
          // onNext={!isEnd && getNext}
          // onPrev={!isStart && getPrev}
          totalItems={totalItems}
          totalPages={totalPages}
          currentPage={currentPage}
          itemsPerPage={itemPerPage}
          goToPage={goToPage} // add goToPage
          isStart={isStart} // add isStart
          isEnd={isEnd} // add isEnd
          getNext={getNext} // add getNext
          getPrev={getPrev} // add getPrev
        />
      )}
    </Fragment>
  );
};

const mapStateToProps = (state, props) => ({
  cpaps: selectCpaps(state.cpaps, { text: "" }),
});

const mapDispatchToProps = (dispatch) => ({
  startSetCpaps: () => dispatch(startSetCpaps()),
  startEditCpap: (id, updates, files) =>
    dispatch(startEditCpap(id, updates, files)),
  startRemoveCpap: (id) => dispatch(startRemoveCpap(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductList);
